// @flow
import i18n from "i18next";
import k from "src/i18n/keys";

import React, { useState, useRef, useMemo } from "react";
import type { Node } from "react";

import {
  AccordionSection,
  AccordionTitle,
  AccordionIcon,
  AccordionText,
  AccordionContent,
  StatusType,
  Count,
} from "./styles";
import Icon from "src/icons";
import Name from "src/components/Status/Name";

type Props = {
  title: number,
  children: Node,
  count: number,
  header: string,
};

const Accordion = ({ title, children, count, header }: Props) => {
  const [active, setActive] = useState(false);
  const contentRef = useRef<Element | null>(null);

  const scrollHeight = useMemo(() => {
    if (contentRef && contentRef.current) {
      return `${contentRef.current.scrollHeight}px`;
    }
    return "auto";
  }, [contentRef]);

  const toggleActive = () => {
    setActive(!active);
  };

  return (
    <AccordionSection>
      <AccordionTitle onClick={toggleActive}>
        <AccordionText>
          <div>
            {header}
            {i18n.t(k._)}
          </div>
          <StatusType>
            <Name id={title} />
          </StatusType>
          <Count>
            {i18n.t(k._1)}
            {count}
            {i18n.t(k._2)}
          </Count>
        </AccordionText>
        <AccordionIcon active={active}>
          <Icon type="triangleDown" />
        </AccordionIcon>
      </AccordionTitle>

      <AccordionContent active={active} scrollHeight={scrollHeight}>
        {active ? children : null}
      </AccordionContent>
    </AccordionSection>
  );
};

export default Accordion;
